import React from "react";
import { object } from "prop-types";
import Select from "react-select";
import "./select.css";
import { optionsType } from "../../prop-types";

const getValue = (options, value) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(value)
      ? value.indexOf(option.value) >= 0
      : value === option.value
  );
};

const FormikSelect = ({
  options,
  field,
  form: { setFieldValue },
  menuIsOpen,
  ...props
}) => {
  const value = getValue(
    options,
    field.value === undefined ? props.value : field.value
  );

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const backgroundColor = (disabled, value) => {
    if (disabled) {
      return "#E9ECEF";
    } else if (value.length) {
      return "#DBFFED";
    } else {
      return "#ffffff";
    }
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: backgroundColor(state.isDisabled, value),
      boxShadow: state.isFocused ? null : null,
      borderColor: state.isFocused ? "#0AD172" : "#ced4da",
      borderRadius: 4,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#DBFFED" : "#ffffff",
        borderBottom: "1px solid #ced4da",
        "&:hover": {
          backgroundColor: "#DBFFED",
        },
      };
    },
    menu: (provided) => ({
      ...provided,
      margin: 0,
      zIndex: 2,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      zIndex: 2,
    }),
    indicatorSeparator: (provided,state) => ({
      ...provided,
      backgroundColor:  state.isDisabled ? "#ced4da" : "#ced4da",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      opacity:  state.isDisabled ? 0.7 : 1,
    })
  };

  return (
    <Select
      menuIsOpen={menuIsOpen}
      {...props}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        backgroundColor: "red",
        colors: {
          ...theme.colors,
          primary25: "#FFFFFF",
          primary: "#0AD172",
          primary50: "#DBFFED",
          neutral10: "red",
        },
      })}
      styles={customStyles}
      className={"dropdown-group"}
      options={options}
      name={field.name}
      value={value}
      onChange={handleChange}
      onBlur={field.onBlur}
    />
  );
};

FormikSelect.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default FormikSelect;



// WEBPACK FOOTER //
// ./src/components/formik/Select.jsx